import { render } from "./StudentGroups.vue?vue&type=template&id=989ed70a"
import script from "./StudentGroups.vue?vue&type=script&lang=js"
export * from "./StudentGroups.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/StudentGroups.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "989ed70a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('989ed70a', __exports__)) {
    api.reload('989ed70a', __exports__)
  }
  
  module.hot.accept("./StudentGroups.vue?vue&type=template&id=989ed70a", () => {
    api.rerender('989ed70a', render)
  })

}


export default __exports__